import { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import { parseMarkdown } from './utils';
import { ProductContext } from '../context';
import css from './index.module.scss';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var FabricDetails = function FabricDetails(_ref) {
  var _fabric$icon;

  var title = _ref.title;

  var _useContext = useContext(ProductContext),
      fabric = _useContext.fabric;

  if (!fabric) {
    return /*#__PURE__*/_jsx(_Fragment, {});
  }

  return /*#__PURE__*/_jsxs("div", {
    className: css.col,
    children: [/*#__PURE__*/_jsxs("div", {
      className: css.panelTitle,
      children: [title, ":"]
    }), /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsxs("div", {
        className: css.fabricTitle,
        children: [((_fabric$icon = fabric.icon) === null || _fabric$icon === void 0 ? void 0 : _fabric$icon.svg) && /*#__PURE__*/_jsx("div", {
          "aria-hidden": "true",
          className: css.fabricIcon,
          dangerouslySetInnerHTML: {
            __html: fabric.icon.svg
          },
          role: "presentation"
        }), /*#__PURE__*/_jsx("div", {
          children: fabric.title
        })]
      }), fabric.description && /*#__PURE__*/_jsx("div", {
        dangerouslySetInnerHTML: {
          __html: parseMarkdown(fabric.description)
        }
      })]
    })]
  });
};

FabricDetails.propTypes = {
  title: PropTypes.string
};
export default /*#__PURE__*/memo(FabricDetails);